<template>

    <edit-form
        :title="title"
        :subTitle="subTitle"
        :schema="schema"
        storeNamespace="services"
        objectNamespace="O_substance"
        :objectId="id"
        :listOnSave="listOnSave"
    >

    </edit-form>

</template>

<script>
import EditForm from '@/components/form/EditForm'

export default {
    name: "ServiceSubstanceForm",
    components: {
        EditForm,
    },
    props: {
        id: {
            type: String
        },
        listOnSave: {
            type: Boolean,
            default: false 
        },
    },
    computed: {
       schema() {
            const filter = {
                name: '{ type:"input", rules:"required" }',
                unit_id: '{type:"selectData", exclude:["update"], rules:"required", storeNamespace: "services", objectNamespace: "A_unit", itemText: "name"}',
                method_id: '{type:"selectData", exclude:["update"], rules:"required", storeNamespace: "services", objectNamespace: "A_method", itemText: "name"}',
                //chemical_formula: '{ type:"input"}',
                description: '{ type:"textarea"}',
            }
            
            return this.$helpers.schemaParser(filter)
        },
        title() {
            return this.id ? "Update service substance" : "New service substance";
        },
        subTitle() {
            return this.id ? "Here you can edit a service substance" : "Here you can create a new service substance";
        },
        
    },
}
</script>

<style>

</style>